// Copyright 2016 Sorama B.V.

import { bindingMode, customAttribute, DOM, inject } from "aurelia-framework";

@customAttribute("dom-observer", bindingMode.twoWay)
@inject(DOM.Element)
export class DomObserver {
    //#region Constants
    public static attachedEventName = "attached";
    public static detachedEventName = "detached";
    //#endregion

    //#region Injected Services
    private element: HTMLElement;
    //#endregion

    constructor(element: HTMLInputElement) {
        this.element = element;
    }

    public attached(): void {
        const attachedEvent = new CustomEvent(DomObserver.attachedEventName, <CustomEventInit>{
            detail: {},
            bubbles: true,
        });

        this.element.dispatchEvent(attachedEvent);
    }

    public detached(): void {
        const detachedEvent = new CustomEvent(DomObserver.detachedEventName, <CustomEventInit>{
            detail: {},
            bubbles: true,
        });

        this.element.dispatchEvent(detachedEvent);
    }

    //#endregion
}
